import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { SocialLoginButton } from '../components/SocialLoginButton';
import { AuthLayout } from '../components/AuthLayout';
import { useAuth } from '../contexts/AuthContext';
export function SignupPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const {
    signup,
    loginWithGoogle
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      await signup(name, email, password);
      navigate('/onboarding');
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleGoogleSignup = async () => {
    setLoading(true);
    try {
      await loginWithGoogle();
      navigate('/onboarding');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return <AuthLayout title="Join FlowQuest" subtitle="Start your journey to flow state productivity" data-id="element-1253">
      {error && <div className="bg-red-50 dark:bg-red-900/20 border-2 border-red-200 dark:border-red-800 rounded-2xl p-4 mb-6" data-id="element-1254">
          <p className="text-red-800 dark:text-red-200 text-sm font-quicksand" data-id="element-1255">
            {error}
          </p>
        </div>}

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1256">
        <Input label="Full Name" placeholder="Alex Johnson" value={name} onChange={e => setName(e.target.value)} required data-id="element-1257" />
        <Input label="Email" type="email" placeholder="hello@example.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-1258" />
        <Input label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-1259" />
        <Input label="Confirm Password" type="password" placeholder="••••••••" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required data-id="element-1260" />

        <Button type="submit" className="w-full mt-4" size="lg" disabled={loading} data-id="element-1261">
          {loading ? 'Creating account...' : 'Create Account'}
        </Button>
      </form>

      <div className="relative my-6" data-id="element-1262">
        <div className="absolute inset-0 flex items-center" data-id="element-1263">
          <div className="w-full border-t border-gray-200 dark:border-gray-700" data-id="element-1264"></div>
        </div>
        <div className="relative flex justify-center text-sm" data-id="element-1265">
          <span className="px-2 bg-game-bg-pink dark:bg-[#1a1d29] text-gray-500" data-id="element-1266">
            Or continue with
          </span>
        </div>
      </div>

      <div className="space-y-3" data-id="element-1267">
        <SocialLoginButton provider="google" onClick={handleGoogleSignup} disabled={loading} data-id="element-1268" />
      </div>

      <p className="text-center text-gray-500 dark:text-gray-400 text-sm mt-6" data-id="element-1269">
        Already have an account?{' '}
        <Link to="/login" className="text-game-coral font-bold hover:underline" data-id="element-1270">
          Log In
        </Link>
      </p>
    </AuthLayout>;
}